import { lazy } from 'react';
import { wrapNavigatorScreen } from '../../../functions/navigation/utils/wrapNavigatorScreen';
import type { BadgeSharePageProps } from './components/BadgeSharePageContent';

const BadgeSharePageContent = lazy(
  () => import('./components/BadgeSharePageContent'),
);

export const BadgeSharePage = wrapNavigatorScreen(
  (props: BadgeSharePageProps) => {
    return <BadgeSharePageContent {...props} />;
  },
  { headerShown: false },
);
